<div class="night-mode-on-off-container">
    <toggle-button #nightModeToggleButton [idText]="'nightModeToggleButton'"></toggle-button>
</div>
